import React from 'react'
import PropTypes from 'prop-types'
import { IndexPageTemplate } from '../../templates/index-page'

const IndexPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <IndexPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        welcometitle={data.welcometitle}
        welcomeinfo={data.welcomeinfo}
        pastorimage={getAsset(data.pastorimage)}
        pastorinfo={data.pastorinfo}
        weeklycalendar={data.weeklycalendar}

        // intro={data.intro || { blurbs: [] }}
        // mainpitch={data.mainpitch || {}}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

IndexPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default IndexPagePreview
